import { useState } from "react";

const CreatePrograms = () => {

  const [title,setTitle] = useState("");
  const [description,setDescription] = useState("");
  const [programDate,setProgramDate] = useState("");
  const [time,setTime] = useState("");
  const [location,setLocation] = useState("");
  const [organizer,setOrganizer] = useState("");
  const [targetAudience,setTargetAudience] = useState("");

  const [photo,setPhoto] = useState(null);
  const [video,setVideo] = useState(null);
  const [pdf,setPdf] = useState(null);

  const [message,setMessage] = useState("");

  const handleSubmit = async (e) => {

    e.preventDefault();

    if(!title || !programDate){
      setMessage("Title and Program Date are required");
      return;
    }

    const formData = new FormData();

    formData.append("title",title);
    formData.append("description",description);
    formData.append("program_date",programDate);
    formData.append("time",time);
    formData.append("location",location);
    formData.append("organizer",organizer);
    formData.append("target_audience",targetAudience);

    if(photo) formData.append("photo",photo);
    if(video) formData.append("video",video);
    if(pdf) formData.append("pdf",pdf);

    try{

      const res = await fetch(
        "https://gp-chandoli-khurd.com/backend/api/program/post_program.php",
        {
          method:"POST",
          body:formData
        }
      );

      const data = await res.json();

      if(data.status === "success"){
        setMessage("Program added successfully ID: " + data.id);

        setTitle("");
        setDescription("");
        setProgramDate("");
        setTime("");
        setLocation("");
        setOrganizer("");
        setTargetAudience("");
        setPhoto(null);
        setVideo(null);
        setPdf(null);
      }
      else{
        setMessage(data.message);
      }

    }catch(err){
      setMessage(err.message);
    }

  };

  return (

    <div className="max-w-4xl mx-auto p-6 bg-white shadow rounded">

      <h2 className="text-2xl font-bold mb-4">Create Program</h2>

      {message && (
        <p className="text-base mb-4 text-green-600">{message}</p>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">

        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e)=>setTitle(e.target.value)}
          className="w-full border p-2 rounded"
          required
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e)=>setDescription(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <input
          type="date"
          value={programDate}
          onChange={(e)=>setProgramDate(e.target.value)}
          className="w-full border p-2 rounded"
          required
        />

        <input
          type="time"
          value={time}
          onChange={(e)=>setTime(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <input
          type="text"
          placeholder="Location"
          value={location}
          onChange={(e)=>setLocation(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <input
          type="text"
          placeholder="Organizer"
          value={organizer}
          onChange={(e)=>setOrganizer(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <input
          type="text"
          placeholder="Target Audience"
          value={targetAudience}
          onChange={(e)=>setTargetAudience(e.target.value)}
          className="w-full border p-2 rounded"
        />

        {/* PHOTO UPLOAD */}
        <div>
          <label className="block mb-1 font-medium">Photo</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e)=>setPhoto(e.target.files[0])}
            className="w-full"
          />
        </div>

        {/* VIDEO UPLOAD */}
        <div>
          <label className="block mb-1 font-medium">Video</label>
          <input
            type="file"
            accept="video/*"
            onChange={(e)=>setVideo(e.target.files[0])}
            className="w-full"
          />
        </div>

        {/* PDF UPLOAD */}
        <div>
          <label className="block mb-1 font-medium">PDF</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e)=>setPdf(e.target.files[0])}
            className="w-full"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Submit
        </button>

      </form>

    </div>

  );
};

export default CreatePrograms;